import React, { Component } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";
import EventBus from "eventing-bus";
import { ACTION_TYPES } from "src/constants";
import { TextInputOne, ButtonOne } from "src/components/form-inputs";
import styles from "./_read-modal.module.scss";

export default class ReadModal extends Component {
  state = {
    isLoading: false,
  };

  componentDidMount() {
    const { data } = this.props;

    this.adminShowSipubscription = EventBus.on(
      ACTION_TYPES.REQUEST_ADMIN_SHOW_SIP,
      () => {
        this.setState({ isLoading: true });
      }
    );

    this.adminShowSipubscriptionSuccess = EventBus.on(
      ACTION_TYPES.ADMIN_SHOW_SIP_SUCCESS,
      (data) => {
        const { oneClickCheckout } = data || {};

        this.setState({ isLoading: false });
        this.formik.setFieldValue("id", oneClickCheckout?.uuid);
        this.formik.setFieldValue("name", oneClickCheckout?.name);
        this.formik.setFieldValue("amount", oneClickCheckout?.amount);
        this.formik.setFieldValue("folioNumber", oneClickCheckout?.folioNumber || 'Not specified yet');
        this.formik.setFieldValue("amcName", oneClickCheckout?.amcName);
        this.formik.setFieldValue("status", oneClickCheckout?.sipStatus?.toUpperCase());
      }
    );

    this.adminShowSipubscriptionFailure = EventBus.on(
      ACTION_TYPES.ADMIN_SHOW_SIP_FAILED,
      () => this.setState({ isLoading: false })
    );

    document.addEventListener(
      "keydown",
      (e) => this.escFunction(e, this),
      false
    );

    this.props.requestAdminShowSip({ uuid: data?.uuid });
  }

  componentWillUnmount() {
    this.adminShowSipubscription();
    this.adminShowSipubscriptionSuccess();
    this.adminShowSipubscriptionFailure();

    document.removeEventListener(
      "keydown",
      (e) => this.escFunction(e, this),
      false
    );
  }

  escFunction(event, props) {
    if (event.key === "Escape" && props?.props?.handleClose) {
      props?.props?.handleClose();
    }
  }

  onCopyLink = ({ link = "" }) => {
    navigator.clipboard.writeText(link);
    toast.success("Link copied to clipboard", "success");
  };

  render() {
    const { show, handleClose, showSip } = this.props;
    return (
      <div>
        <input id="input-link" className={styles["link-input"]} />
        <Dialog
          open={show}
          fullWidth={true}
          maxWidth="md"
          onClose={handleClose}
        >
          <DialogTitle> "SIP/Mandate Transaction Detail"</DialogTitle>
          <Formik
            initialValues={{
              id: "",
              amount: "",
              fund: "",
              status: "",
            }}
            onSubmit={handleClose}
            innerRef={(ref) => (this.formik = ref)}
          >
            <Form>
              <div className={styles["content"]}>
                {showSip?.oneClickCheckout?.shortLink && (
                  <div>
                    <br />
                    <div className={styles["link"]}>
                      <a href="#">{showSip?.oneClickCheckout?.shortLink}</a>
                    </div>
                    <div
                      className={styles["copy-link"]}
                      onClick={() =>
                        this.onCopyLink({
                          link: showSip?.oneClickCheckout?.shortLink,
                        })
                      }
                    >
                      <img src="/img/copylink.svg" alt="copylink" />← Please
                      click to copy this transaction
                    </div>
                    <br />
                    <br />
                  </div>
                )}
                <TextInputOne
                  name="id"
                  id="id"
                  label="UUID"
                  type="text"
                  placeholder="ID"
                  sizeType="medium"
                  disabled
                />
                <TextInputOne
                  name="name"
                  id="name"
                  label="User Name"
                  type="text"
                  placeholder="User Name"
                  sizeType="medium"
                  disabled
                />
                <TextInputOne
                  name="folioNumber"
                  id="folioNumber"
                  label="Folio Number"
                  type="text"
                  placeholder="Folio Number"
                  sizeType="medium"
                  disabled
                />
                <TextInputOne
                  name="amount"
                  id="amount"
                  label="Amount"
                  type="text"
                  placeholder="Amount"
                  sizeType="medium"
                  disabled
                />
                <TextInputOne
                  name="amcName"
                  id="amcName"
                  label="Amc Name"
                  type="text"
                  placeholder="amcName"
                  sizeType="medium"
                  disabled
                />
                <TextInputOne
                  name="status"
                  id="status"
                  label="Status"
                  type="text"
                  placeholder="Status"
                  sizeType="medium"
                  disabled
                />
                <div className={styles["footer"]}>
                  <ButtonOne type="submit">OK</ButtonOne>
                </div>
              </div>
            </Form>
          </Formik>
        </Dialog>
      </div>
    );
  }
}
